import { Component, Input, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { SimulationPeersReschedulePage } from '../../simulation-peers-reschedule/simulation-peers-reschedule.page';
import { SimpleCardComponent } from '../simple-card/simple-card.component';
import { AuthService } from 'src/app/_services/auth.service';
import { ComponentBase } from '../../_utils/component.base';
import { ModuleEnum } from '../../_utils/unums/module.enum';
import { UserScheduledSimulationsService } from 'src/app/_services/user-scheduled-simulations.service';
import { SimulationService } from 'src/app/_services/simulation.service';
import { UserService } from 'src/app/_services/user.service';

@Component({
  selector: 'app-p2p-card',
  templateUrl: './p2p-card.component.html',
  styleUrls: ['./p2p-card.component.scss'],
})
export class P2pCardComponent extends ComponentBase implements OnInit {

  peerName;
  isMobile = true;

  simulationSelectedData;

  backgroundColor = 'no-simulation';
  title = 'Programmed simulation';

  user;

  enteredFirst;

  rescheduleSent = false;
  recheduleRecived = false;

  @Input() simulation;
  @Input() startedSimulation = false;
  @Input() simulationMinutesToStart;
  @Input() simulationTimeFromNow;
  @Input()
  public module: ModuleEnum;

  constructor(
    public modalCtrl: ModalController,
    private platform: Platform, private authService: AuthService,
    private userScheduledSimulationsService: UserScheduledSimulationsService,
    private simulationService: SimulationService,
    private userService: UserService
  ) {
    super();
    if (this.platform.is('mobile')) this.isMobile = true;
    else this.isMobile = false;
  }

  async ngOnInit() {
    this.peerName = await  this.userService.getPeerName(this.simulation.peerId);
    this.simulation.peerName = this.peerName;

    this.user = await this.authService.getUser();

    if (this.simulation.selected_sim_key) {
      this.simulationSelectedData = await this.simulationService
        .getSimulationMetadata(this.module, this.simulation.selected_sim_key);
      if(this.simulationSelectedData) {
        this.backgroundColor = this.simulationSelectedData.color;
        this.title = this.simulationSelectedData.name;
      }
    }

    if (this.simulation.reschedule && !this.simulation.reschedule.hasToAccept) this.rescheduleSent = true;

    if (this.simulation.reschedule && this.simulation.reschedule.hasToAccept) this.recheduleRecived = true;

    if (this.startedSimulation && !this.simulation.selected_sim_key) this.title = 'Time to practice!'
  }

  async goToSimulationList() {
    await this.navigateAndSaveUserJourneyP2P([this.module, 'simulations-peers-list'], {queryParams: {id: this.simulation.key}});
  }

  async rescheduleSimulation() {
    let modalClass = '';
    if (!this.isMobile) modalClass = 'reschedule-modal-css'
    const modal = await this.modalCtrl.create({
      component: SimulationPeersReschedulePage,
      backdropDismiss: false,
      cssClass: modalClass,
      componentProps: { simulation: this.simulation }
    });

    return await modal.present();
  }

  async openContextModal() {
    const modal = await this.modalCtrl.create({
      component: SimpleCardComponent,
      backdropDismiss: true,
      cssClass: 'card-modal',
      componentProps: {
        title: this.simulationSelectedData.name,
        description: this.simulationSelectedData.description,
        headerColor: 'blue',
        descriptionTitle: 'Scenario',
        showCloseIcon: true,
      },
    });

    return await modal.present();
  }

  async startSimulation() {
    this.storage.set('scheduled-simulation', this.simulation);
    if (this.simulation.selected_sim_key) {
      await this.navigateAndSaveUserJourneyP2P([this.module, 'simulations-peers-msg'], {queryParams: {id: this.simulation.key}});
      this.updateUserFlowState('chose-simulation');

      this.enteredFirst = this.simulation.enteredFirst;

      // Update that the current user entered first and their peer will be second
      if (this.enteredFirst === undefined) {
        this.enteredFirst = true;
        await this.userScheduledSimulationsService.updateSimulationDetails(this.user.uid, this.simulation.key, {
          enteredFirst: true,
          simulationId: this.simulation.selected_sim_key,
        });
        await this.userScheduledSimulationsService.updateSimulationDetails(this.simulation.peerId, this.simulation.key, {
          enteredFirst: false,
          peerSimulationId: this.simulation.selected_sim_key,
        });
      }
      // Update that the current user, who is the peer that entered second, is now logged in (to raise a toast)
      else if (this.enteredFirst === false) {
        this.enteredFirst = false;
        await this.userScheduledSimulationsService.updateSimulationDetails(this.user.uid, this.simulation.key, {
          simulationId: this.simulation.selected_sim_key,
        });
        await this.userScheduledSimulationsService.updateSimulationDetails(this.simulation.peerId, this.simulation.key, {
          peerEntered: true,
          peerSimulationId: this.simulation.selected_sim_key,
        });
      }
    }
    else {
      await this.navigateAndSaveUserJourneyP2P(
        [this.module, 'simulations-peers-list'],
        { queryParams: { id: this.simulation.key, simStarted: true } }
      );
    }
  }

  updateUserFlowState(status) {
    this.userScheduledSimulationsService.updateSimulationDetails(this.user.uid, this.simulation.key, { status });
    this.userScheduledSimulationsService.updateSimulationDetails(this.simulation.peerId, this.simulation.key, { status_peer: status });
  }

}
